module.exports = __webpack_public_path__ + "static/media/tick.7f530a47.svg";